
import axios from 'axios'
import { Fragment, useState } from 'react'
import { useCookies } from 'react-cookie'
import { BsFillMoonStarsFill } from 'react-icons/bs'
import { CgSun } from 'react-icons/cg'
import { GrClose } from 'react-icons/gr'
import { Link } from 'react-router-dom'
import { capitalizeWords, formatToCurrency } from '../../Utils/general'
import { useStateValue } from '../../Utils/StateProvider'

const Settings = ({ display }) => {
    const [{ activeTheme, url, customer, showBalance }, payload] = useStateValue()
    const [dailyLimit, setDailyLimit] = useState(customer?.daily_limit)
    const [monthlyLimit, setMonthlyLimit] = useState(customer?.monthly_limit)
    const [reset, setReset] = useState(false)
    const [passData, setPassData] = useState({})
    const [cookies] = useCookies(['bearerToken'])

    const apply = async id => {
        const options = {
            headers: {
                Authorization: `Bearer ${cookies.bearerToken}`
            }
        }
        let setters
        let validators = {
            uid: customer?.uid
        }

        payload({
            type: 'TOGGLE_PROCESSING_DASH',
            state: true
        })

        switch (id) {
            case 'daily-limit':
                setters = {
                    daily_limit: dailyLimit
                }
                break;
            case 'monthly-limit':
                setters = {
                    monthly_limit: monthlyLimit
                }
                break;
            case 'password':
                if (
                    !passData.old ||
                    !passData.new ||
                    !passData.confirm
                ) return payload({
                    type: 'SET_NOTIFY',
                    data: {
                        text: 'Missing required parameters. Please complete form requirement(s) and resubmit.',
                        type: 'error'
                    }
                })
                if (
                    passData.new !== passData.confirm
                ) payload({
                    type: 'SET_NOTIFY',
                    data: {
                        text: 'Passwords do not match. Match passwords and resubmit.',
                        type: 'error'
                    }
                })

                setters = {
                    password: passData.new
                }
                validators.password = passData.old
                break;
            case '2fa':
                console.log('2fa')
                setters = {
                    '2fa': customer['2fa'] === 1 ? 0 : 1
                }
                break;
        }

        try {
            const data = {
                validators,
                setters
            }

            await axios.patch(`${url}/api/u`, data, options)
            const _customer = await axios.get(`${url}/api/u?uid=${customer?.uid}`, options)

            payload({
                type: 'SET_CUSTOMER',
                data: _customer.data.data
            })
            if (id === 'password') payload({
                type: 'SET_NOTIFY',
                data: {
                    text: 'Your password has been modified successfully.',
                    type: 'success'
                }
            })
        } catch (err) {
            return payload({
                type: 'SET_NOTIFY',
                data: {
                    text: err.response.data.message,
                    type: 'error'
                }
            })
        } finally {
            setPassData({})
            payload({
                type: 'TOGGLE_PROCESSING_DASH',
                state: false
            })
        }
    }

    return (
        <div className='settings'>
            <div className='settings-container'>
                <GrClose onClick={() => payload({ type: 'TOGGLE_SETTINGS', display: null })} />
                <div className='settings-controller'>
                    <ul>
                        <li
                            className={display === 'account' ? 'active' : ''}
                            onClick={() => payload({ type: 'TOGGLE_SETTINGS', display: 'account' })}
                        >Account</li>
                        <li
                            className={display === 'security' ? 'active' : ''}
                            onClick={() => payload({ type: 'TOGGLE_SETTINGS', display: 'security' })}
                        >Security</li>
                        <li
                            className={display === 'appearance' ? 'active' : ''}
                            onClick={() => payload({ type: 'TOGGLE_SETTINGS', display: 'appearance' })}
                        >Appearance</li>
                    </ul>
                </div>
                <div className='settings-display'>
                    {
                        display === 'account' && (
                            <div className='settings-node account'>
                                <h3>Account Settings</h3>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Daily limit</h1>
                                        <h3>{formatToCurrency(dailyLimit, customer?.currency)}</h3>
                                        <div className='range-scroll'>
                                            <input type='range' min='0' max='100000' value={dailyLimit} onChange={e => setDailyLimit(e.target.value)} />
                                        </div>
                                        {
                                            parseFloat(customer?.daily_limit) !== parseFloat(dailyLimit) && (
                                                <button onClick={() => apply('daily-limit')}>Apply</button>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Monthly limit</h1>
                                        <h3>{formatToCurrency(monthlyLimit, customer?.currency)}</h3>
                                        <div className='range-scroll'>
                                            <input type='range' min='0' max='1000000' value={monthlyLimit} onChange={e => setMonthlyLimit(e.target.value)} />
                                        </div>
                                        {
                                            parseFloat(customer?.monthly_limit) !== parseFloat(monthlyLimit) && (
                                                <button onClick={() => apply('monthly-limit')}>Apply</button>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className='settings-row'>
                                    <p>want more customization with account limits? <Link to='/support'>contact support</Link></p>
                                </div>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Show/Hide balance</h1>
                                        <div
                                            className={showBalance ? 'toggle-btn active' : 'toggle-btn'}
                                            onClick={() => payload({ type: 'SET_SHOW_BALANCE', state: !showBalance })}
                                        >
                                            <div
                                                className='knob'
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        display === 'security' && (
                            <div className='settings-node security'>
                                <h3>Security Settings</h3>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Setup 2FA (Two Factor Authentication) System.</h1>
                                        <div
                                            className={parseInt(customer['2fa']) === 1 ? 'toggle-btn active' : 'toggle-btn'}
                                            onClick={() => apply('2fa')}
                                        >
                                            <div
                                                className='knob'
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h3>Reset Password</h3>
                                        {
                                            !reset && (
                                                <button onClick={() => setReset(true)}>Reset Now</button>
                                            )
                                        }
                                    </div>
                                </div>

                                {
                                    reset && (
                                        <Fragment>
                                            <div className='settings-row'>
                                                <div className='settings-column'>
                                                    <input
                                                        type='password'
                                                        name='old-pass'
                                                        id='old-pass'
                                                        value={passData.old || ''}
                                                        onChange={e => setPassData({...passData, old: e.target.value})}
                                                        required
                                                    />
                                                    <label htmlFor='old-pass'>Old Password</label>
                                                </div>
                                            </div>
                                            <div className='settings-row'>
                                                <div className='settings-column'>
                                                    <input
                                                        type='password'
                                                        name='new-pass'
                                                        id='new-pass'
                                                        value={passData.new || ''}
                                                        onChange={e => setPassData({...passData, new: e.target.value})}
                                                        required
                                                    />
                                                    <label htmlFor='new-pass'>New Password</label>
                                                </div>
                                                <div className='settings-column'>
                                                    <input
                                                        type='password'
                                                        name='confirm-pass'
                                                        id='confirm-pass'
                                                        value={passData.confirm || ''}
                                                        onChange={e => setPassData({...passData, confirm: e.target.value})}
                                                        required
                                                    />
                                                    <label htmlFor='confirm-pass'>Confirm Password</label>
                                                </div>
                                            </div>
                                            <div className="settings-row">
                                                <div className="settings-column">
                                                    <button onClick={() => apply('password')}>Apply</button>
                                                    <strong className='cancel' onClick={() => setReset(false)}>cancel</strong>
                                                </div>
                                            </div>
                                        </Fragment>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        display === 'appearance' && (
                            <div className='settings-node appearance'>
                                <h3>Appearance Settings</h3>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Theme</h1>
                                        <div className="theme-container">
                                        {
                                            activeTheme === 'light' ? 
                                                <BsFillMoonStarsFill className="left" onClick={() => payload({ type: 'SET_THEME', theme: 'dark'})} /> : 
                                                <CgSun className="right" onClick={() => payload({ type: 'SET_THEME', theme: 'light'})} />
                                        }
                                        </div>
                                    </div>
                                </div>
                                <div className='settings-row'>
                                    <div className='settings-column'>
                                        <h1>Home page</h1>
                                        <hr />
                                        <select
                                            name='home_page'
                                            id='home_page'
                                            defaultValue={localStorage.getItem('home_page') || 'dashboard'}
                                            onClick={e => localStorage.setItem('home_page', e.target.value)}
                                        >
                                            {
                                                ['dashboard', 'payments', 'cards', 'services'].map((page, index) => (
                                                    <option value={page}>{capitalizeWords(page)}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default Settings
